module.exports = __webpack_public_path__ + "img/quiz_03.30da9e2b.jpg";